import {
	Card,
	Row,
	Col,
} from "reactstrap";
import NotificationAlert from "react-notification-alert";
import React, {useRef} from "react";
import LoginFragment from "../../components/Core/LoginFragment";

const securityGroups = [
	"purchaser"
]

const PurchaserLogin = (props) =>
{
	const notifyRef = useRef();
	const forgotPassCode = props.match.params.code;

	return (
		<>
			<NotificationAlert ref={notifyRef}/>
			<Row style={{marginBottom: "40px"}}>
				<Col md={12} className="text-center">
					<h1 style={{color: "#ffc3a9", textShadow: "2px 2px 6px #000000cd", fontSize: "48px"}}>Welcome to<br/>Ncentiva Purchases Platform.</h1>
				</Col>
			</Row><br/>
			<Col lg="5" md="7">
				<Card className="bg-secondary border-0" style={{boxShadow: "5px 7px 25px #0000004d", color: "#121212"}}>
					<LoginFragment notifyArea={notifyRef} titleBgColor="rgb(255, 173, 154)" titleColor="#333333" destination={"/purchaser/dashboard"} securityGroup={securityGroups} setAuthData={props.setAuthData} forgotPassCode={forgotPassCode}/>
				</Card>
			</Col>
		</>
	);
};

export default PurchaserLogin;
